/**
 * IMPORTS
 */

const dataTitleUsuariosCliente = [
  { label: "Nome", accessor: "nome", limit: 60 },
  { label: "E-mail", accessor: "email", limit: 120 },
  {
    label: "Situação",
    accessor: "status",
    isBadge: true,
    badgeClassName: "bg-green-500",
  },
  { label: "Data criação", accessor: "data_criacao" },
];

/**
 * EXPORT
 */
export { dataTitleUsuariosCliente };
